import React from 'react';

export const TermsOfUse = () => <a href="https://www.iubenda.com/terms-and-conditions/38991928" className="iubenda-nostyle no-brand iubenda-embed" title="Terms and Conditions ">Terms and Conditions</a>
export const PrivacyPolicy = () => <a href="https://www.iubenda.com/privacy-policy/38991928" className="iubenda-nostyle no-brand iubenda-embed iub-legal-only" title="Privacy Policy ">Privacy Policy</a>
